import { ingestAPIObject } from "../utils/api";
export class CoolerDTO {
    constructor(jsonData) {
        ingestAPIObject(this, jsonData);
        this.customerId = jsonData.customerId ?? 0;
        this.glassbitWarehouseId = jsonData.glassbitWarehouseId ?? 0;
    }
}
